/* NZS-SPD-0808 — assets/nzs-header-mega.js
   EXTRACTED VERBATIM from the inline <script> at sections/nzs-header.liquid:350-656 (the
   "mega-menu: the pill grows as ONE card" block: mega pill open/close, the NZS-ONEOPEN surface
   registry, the NZS-MEGABD backdrop + cursor bubble, the search bar, and nzsSetSpacer / the
   compact-header IntersectionObserver). 19,994 B of inline JS off every single page's HTML.

   The block contained ZERO Liquid interpolation (verified: no `{{`, no `{%` anywhere in
   :350-656), so the body below is byte-for-byte the original. Verify with:
     tail -n +<lines-in-this-header+1> assets/nzs-header-mega.js  ->  sha1 141cd70ec685...

   LOAD ORDER MATTERS. The section emits this with `defer` at the SAME position the inline block
   occupied, i.e. AFTER `nzs-overlay.js` (nzs-header.liquid:349) and BEFORE nzs-header-drawer.js.
   `defer` scripts run in document order, so: overlay -> mega -> drawer, which is the order the
   drawer needs (it consumes window.__nzsSurfaces / __nzsCloseAllExcept defined here, and
   window.nzsOverlay from the overlay asset).
*/
/* ===== mega-menu: the pill grows as ONE card; open on CLICK (arrow toggles, word navigates) ===== */
(function(){
  var pill = document.querySelector('.pill');
  var items = Array.prototype.slice.call(document.querySelectorAll('.nav-item'));
  var megas = Array.prototype.slice.call(document.querySelectorAll('.pill-drawer .mega'));
  /* ===== NZS-ONEOPEN 2026-07-17 — only ONE of {mega, search, cart, more, mnav} open at a time =====
     Each surface registers its closer in __nzsSurfaces (shared across this file's two IIFEs, same
     __nzs* global convention as __nzsSearchClose); every open path calls __nzsCloseAllExcept(key)
     BEFORE it opens. No recursion: the helper skips the surface being opened and every closer only
     strips state. Scroll-lock stays correct — each opener sets its own lock AFTER this runs. */
  window.__nzsSurfaces = window.__nzsSurfaces || {};
  /* NZS-SPD-0927-SM-N1: an optional second argument is handed to every closer (nzs-skeleton.js passes {restoreFocus:false}:
     the page is leaving, and a focus restore there forced a second whole-document style recalc before the skeleton's first
     frame). Every other caller passes nothing, so every closer is called exactly as before. */
  window.__nzsCloseAllExcept = function(which, opts){
    var s = window.__nzsSurfaces;
    Object.keys(s).forEach(function(k){ if(k!==which && typeof s[k]==='function'){ try{ if(opts) s[k](opts); else s[k](); }catch(_){} } });
  };
  window.__nzsSurfaces.mega = function(){ closeMenu(); };
  function setExp(it,on){ var b=it.querySelector('.chevbtn'); if(b) b.setAttribute('aria-expanded',on?'true':'false'); }
  /* NZS-XOUT-0928 (Blake): Speed Lab X-cursor recipe. #nzsX = position only (translate3d, NO transition);
     inner <i> = scale/opacity. In after a 90 ms arm; out = the entrance played backwards on the NZ Performance
     curve when the surface closes or the pointer moves into the panel, hidden by a 320 ms timer (never rAF), and
     it keeps following while it shrinks. Back onto the backdrop mid-exit resumes from the current size. The real
     mouse position is tracked globally, so the X only ever appears where the pointer is (no fly-in).
     Contract kept: bind(backdrop[, panel]) / unbind(backdrop). ponytail: no popover layer, NZS has no <dialog>. */
  var xEl, xDot, xOn=null, xPanel=null, xHover=false, xArm=0, xOut=0, xPt=null;
  var xEnabled=window.matchMedia('(pointer:fine) and (prefers-reduced-motion:no-preference)');
  function xMouse(e){ return !e.pointerType || e.pointerType==='mouse'; }
  function xPlace(x,y){ xEl.style.transform='translate3d('+x+'px,'+y+'px,0)'; }
  /* off the panel's visual box AND its resting layout box: a panel still sliding in counts as inside */
  function xOff(p,x,y){ var r=p.getBoundingClientRect(), L=p.offsetLeft, T=p.offsetTop, o=function(a,b,c,d){ return x<a||x>c||y<b||y>d; };
    return o(r.left,r.top,r.right,r.bottom) && o(L,T,L+p.offsetWidth,T+p.offsetHeight); }
  function xOnBd(x,y,t){ t=t||document.elementFromPoint(x,y);
    return !!(t && t.nodeType===1 && (t===xOn || xOn.contains(t)) && (!xPanel || xOff(xPanel,x,y))); }
  function xLeave(){
    clearTimeout(xOut); xOut=0; clearTimeout(xArm); xArm=0; xHover=false;
    if(xEl){ xEl.classList.remove('out','on','down'); xDot.style.cssText='transition:none;transform:scale(0);opacity:0'; }
    if(xOn) xOn.classList.remove('nzs-x-live');
  }
  function xFadeOut(){
    if(!xEl || !xEnabled.matches || !xEl.classList.contains('on')){ xLeave(); return; }
    xHover=false; clearTimeout(xArm); xArm=0;
    if(xOn) xOn.classList.remove('nzs-x-live');
    xEl.classList.add('out'); xEl.classList.remove('on','down');
    clearTimeout(xOut); xOut=setTimeout(function(){ xOut=0; xLeave(); },320);
  }
  function xMove(e){
    if(!xMouse(e)) return;
    xPt={x:e.clientX,y:e.clientY};
    if(!xOn && !xOut) return;
    if(!xEnabled.matches || document.hidden){ if(xHover||xOut) xLeave(); return; }
    if(!xOn){ xPlace(e.clientX,e.clientY); return; } /* closed mid-exit: keep following while it shrinks */
    if(!xOnBd(e.clientX,e.clientY,e.target)){ if(xHover) xFadeOut(); else if(xOut) xPlace(e.clientX,e.clientY); return; }
    if(!xHover && xOut){ /* resume mid-exit from the current scale */
      clearTimeout(xOut); xOut=0; xHover=true; xPlace(e.clientX,e.clientY);
      xEl.classList.remove('out'); xEl.classList.add('on'); xOn.classList.add('nzs-x-live'); return;
    }
    if(!xHover){ /* fresh entrance AT the pointer */
      xHover=true; xEl.classList.remove('on','down','out');
      xDot.style.cssText='transition:none;transform:scale(0);opacity:0'; xPlace(e.clientX,e.clientY);
      void xEl.offsetWidth; xDot.style.cssText=''; xOn.classList.add('nzs-x-live');
      xArm=setTimeout(function(){ xArm=0; if(xHover && xOn) xEl.classList.add('on'); },90);
      return;
    }
    xPlace(e.clientX,e.clientY);
  }
  document.addEventListener('pointermove',xMove,{passive:true});
  document.addEventListener('pointerdown',function(e){ if(xMouse(e) && xHover && xEl) xEl.classList.add('down'); },{passive:true});
  document.addEventListener('pointerup',function(){ if(xEl) xEl.classList.remove('down'); },{passive:true});
  /* instant resets: pointer leaves the window, blur, hidden tab, page leave, reduced-motion change */
  document.documentElement.addEventListener('pointerleave',function(){ xPt=null; xLeave(); });
  window.addEventListener('blur',xLeave);
  window.addEventListener('pagehide',xLeave);
  document.addEventListener('visibilitychange',function(){ if(document.hidden) xLeave(); });
  xEnabled.addEventListener('change',function(){ xLeave(); if(xOn) xOn.classList.toggle('nzs-x-ready',xEnabled.matches); });
  window.__nzsX={
    bind:function(s,panel){
      if(!s) return;
      if(!xEl){ xEl=document.createElement('div'); xEl.id='nzsX'; xEl.setAttribute('aria-hidden','true');
        xEl.innerHTML='<i><svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 30L30 10M10 10L30 30"/></svg></i>';
        document.body.appendChild(xEl); xDot=xEl.firstElementChild; }
      if(xOn===s){ if(panel) xPanel=panel; return; }
      if(xOn) xOn.classList.remove('nzs-x-ready','nzs-x-live');
      xLeave(); /* open / switch = instant reset, cancels any exit in flight */
      xOn=s; xPanel=panel||null; s.classList.toggle('nzs-x-ready',xEnabled.matches);
      /* known pointer: the X appears where it IS; unknown (keyboard open): wait for a real move */
      if(xPt && xEnabled.matches && !document.hidden) xMove({clientX:xPt.x,clientY:xPt.y});
    },
    unbind:function(s){ if(!s || xOn!==s) return; xFadeOut(); s.classList.remove('nzs-x-ready'); xOn=null; xPanel=null; }
  };
  /* NZS-MEGABD-JS v4: backdrop only */
  function getMegaBd(){
    var bd = document.getElementById('nzsMegaBd');
    if(!bd){
      bd = document.createElement('div');
      bd.id = 'nzsMegaBd';
      bd.setAttribute('aria-hidden','true');
      document.body.appendChild(bd);
      bd.addEventListener('click', closeMenu);
    }
    return bd;
  }
  function openMenu(key){
    if(window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('mega');
    items.forEach(function(it){ var on=it.dataset.menu===key; it.classList.toggle('open',on); setExp(it,on); });
    megas.forEach(function(mg){ mg.classList.toggle('active', mg.dataset.mega===key); if(mg.dataset.mega===key) mg.querySelectorAll('img[loading="lazy"]').forEach(function(i){ i.loading='eager'; }); }); /* NZS-MEGA-IMG-1023: lazy tiles in a just-shown panel could stay unloaded (Protein, first tile); load them on open */
    if(pill) pill.classList.add('open');
    getMegaBd();
    document.body.classList.add('nzs-mega-open');
    __nzsX.bind(getMegaBd());
  }
  function closeMenu(){
    items.forEach(function(it){ it.classList.remove('open'); setExp(it,false); });
    megas.forEach(function(mg){ mg.classList.remove('active'); });
    if(pill) pill.classList.remove('open');
    document.body.classList.remove('nzs-mega-open');
    var _bd=document.getElementById('nzsMegaBd'); if(_bd) __nzsX.unbind(_bd);
  }
  /* NZS-ROUND4-D-LINK-CLOSE: close visually in capture, but never own navigation. */
  var pillDrawer=pill&&pill.querySelector('.pill-drawer');
  if(pillDrawer) pillDrawer.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a');
    if(!a||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    if((a.target&&a.target!=='_self')||!document.body.classList.contains('nzs-mega-open')) return;
    pill.classList.add('nzs-mega-fastclose');
    closeMenu();
    setTimeout(function(){if(pill)pill.classList.remove('nzs-mega-fastclose');},400);
  },true);
  function isOpen(key){ return items.some(function(it){ return it.dataset.menu===key && it.classList.contains('open'); }); }
  /* ARROW (button) toggles its own mega on CLICK; the WORD (<a>) navigates natively — no hover-to-open */
  document.querySelectorAll('.chevbtn[data-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault(); if (e.detail > 0) this.blur(); e.stopPropagation();
      var key=btn.dataset.toggle;
      isOpen(key) ? closeMenu() : openMenu(key);
    });
  });
  /* close on: same-arrow / other-arrow click (handled above), outside click, or Escape */
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeMenu(); });
  document.addEventListener('click', function(e){ if(!e.target.closest('.pill')) closeMenu(); });
  /* deep-link an open panel for review: #menu=brand|category|goal|is */
  var m = (location.hash.match(/menu=(\w+)/)||[])[1];
  if(m) openMenu(m);
  var sc = (location.hash.match(/scroll=(\d+)/)||[])[1];
  /* NZS-SCROLLSPY2-0816: review-only deep link. '0' is truthy — never write top,
     and consume the hash so bfcache/back never replays it. */
  if(sc && +sc > 0){ window.scrollTo(0, +sc); try{ history.replaceState(history.state, '', location.pathname + location.search); }catch(e){} }
  /* search bar below the header (spyglass = toggle) */
  var sb = document.getElementById('nzsSearchbar');
  var sTog = document.querySelector('#navsearch .navsearch__toggle');
  if(sb && sTog){
    var inp = sb.querySelector('.nzs-searchbar__input');
    var frm = sb.querySelector('.nzs-searchbar__form');
    var res = document.getElementById('nzsSearchResults');
    var status = document.getElementById('nzsSearchStatus');
    var sCtrl = null, sDeb = null, sLoad = null, sSeq = 0;
    /* Popular searches map to real categories/brands; query suggestions + typo tolerance come from Shopify's suggest API. */
    var POPULAR = ['Whey Protein','Pre-Workout','Creatine','Electrolytes','BCAA & EAA','Mass Gainer','Protein Bars','Collagen'];
    var RKEY = 'nzsRecent';
    function esc(t){ return String(t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
    function safeStyled(t){
      /* Shopify's suggest API styled_text mixes tags (<mark>un</mark><span>flavoured</span>);
         only <mark> was whitelisted, so the <span> half printed as literal text in the dropdown.
         Normalize: highlight tags render as <strong> (styled by .nzs-sbr__qrow strong, no
         browser-yellow mark); wrapper tags are dropped but their TEXT kept; all else escaped. */
      var out='', re=/<(\/?)\s*(mark|strong|b|em|span)\b[^>]*>/gi, m, last=0; t=String(t);
      while((m=re.exec(t))){
        out+=esc(t.slice(last,m.index));
        var tg=m[2].toLowerCase();
        if(tg==='mark'||tg==='strong'||tg==='b'){ out+= m[1]==='/' ? '</strong>' : '<strong>'; }
        last=re.lastIndex;
      }
      return out+esc(t.slice(last));
    }
    function announce(n){ if(status) status.textContent=n+' suggestion'+(n===1?'':'s'); }
    /* NZS-SPEED-LDR: suggest fetch feedback appears only after 250ms and is sequence-safe. */
    function clearSuggestBusy(){ clearTimeout(sLoad); sLoad=null; var d=res.querySelector('[data-nzs-suggest-loading]'); if(d) d.remove(); res.removeAttribute('aria-busy'); }
    function cancelSuggest(){ ++sSeq; clearTimeout(sDeb); if(sCtrl) sCtrl.abort(); sCtrl=null; clearSuggestBusy(); }
    function hideRes(){ cancelSuggest(); res.hidden = true; res.innerHTML = ''; if(status) status.textContent=''; }
    function getRecent(){ try{ return (JSON.parse(localStorage.getItem(RKEY))||[]).slice(0,6); }catch(e){ return []; } }
    function pushRecent(q){ q=(q||'').trim(); if(q.length<2) return; try{ var r=getRecent().filter(function(x){ return x.toLowerCase()!==q.toLowerCase(); }); r.unshift(q); localStorage.setItem(RKEY, JSON.stringify(r.slice(0,6))); }catch(e){} }
    function bindClear(){ var c=res.querySelector('[data-clear]'); if(c) c.addEventListener('click', function(e){ e.preventDefault(); try{ localStorage.removeItem(RKEY); }catch(_){} defaultPanel(); }); }
    function mkPill(label){ return '<a class="nzs-sbr__pill" data-q="'+esc(label)+'" href="/search?q='+encodeURIComponent(label)+'&type=product">'+esc(label)+'</a>'; }
    function grp(label, inner){ return '<div class="nzs-sbr__grp"><div class="nzs-sbr__lbl">'+label+'</div>'+inner+'</div>'; }
    function thumb(u){ return u ? '<img src="'+esc(u)+(u.indexOf('?')>-1?'&':'?')+'width=96" alt="" loading="lazy">' : ''; } /* NZS-NOSLOT-0905: no grey disc when a collection has no image */
    function defaultPanel(){
      if(status) status.textContent='';
      var recent=getRecent(), html='';
      if(recent.length){ html += '<div class="nzs-sbr__grp"><div class="nzs-sbr__lbl">Recent <button type="button" class="nzs-sbr__clear" data-clear>Clear</button></div><div class="nzs-sbr__pills">'+recent.map(mkPill).join('')+'</div></div>'; }
      html += '<div class="nzs-sbr__grp"><div class="nzs-sbr__lbl">Popular searches</div><div class="nzs-sbr__pills">'+POPULAR.map(mkPill).join('')+'</div></div>';
      res.innerHTML=html; res.hidden=false; bindClear();
    }
    function noResults(q){
      return '<div class="nzs-sbr__empty">No matches for \u201c'+esc(q)+'\u201d. Try a brand or category:</div>'
        + '<div class="nzs-sbr__grp"><div class="nzs-sbr__pills">'+POPULAR.map(mkPill).join('')+'</div></div>'
        + '<a class="nzs-sbr__all" href="/collections/shop-all">Browse all products</a>';
    }
    function renderResults(q, d){
      var r=(d && d.resources && d.resources.results) || {};
      var queries=r.queries||[], prods=r.products||[];
      /* NZS-SEARCH-SYSCOLL-0922: internal family collections are not shopper-facing */
      var cols=(r.collections||[]).filter(function(c){ return !(/\/collections\/nzs-family-/.test(c.url||'') || /^\s*\[system\]/i.test(c.title||'')); });
      if(!queries.length && !cols.length && !prods.length){ res.innerHTML=noResults(q); res.hidden=false; announce(0); return; }
      var html='';
      if(queries.length){
        html += grp('Suggestions', queries.slice(0,4).map(function(it){
          var label=it.styled_text ? safeStyled(it.styled_text) : esc(it.text||q);
          return '<a class="nzs-sbr__qrow" role="option" data-q="'+esc(it.text||'')+'" href="/search?q='+encodeURIComponent(it.text||q)+'&type=product"><svg class="nzs-sbr__qic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg><span>'+label+'</span></a>';
        }).join(''));
      }
      if(cols.length){
        html += grp('Collections', cols.slice(0,3).map(function(c){
          var u=(c.featured_image&&c.featured_image.url)||c.image||'';
          return '<a class="nzs-sbr__row" role="option" href="'+esc(c.url)+'">'+thumb(u)+'<span class="nzs-sbr__t">'+esc(c.title)+'</span><span class="nzs-sbr__tag">Collection</span></a>';
        }).join(''));
      }
      if(prods.length){
        html += grp('Products', prods.map(function(p){
          var u=p.featured_image && p.featured_image.url;
          /* NZS-SBR-COMPARE: show struck compare-at price when the product is on sale */
          var _cap=parseFloat(p.compare_at_price_min||0), _pr=parseFloat(p.price||0);
          var _ph = (_cap>_pr)
            ? '<span class="nzs-sbr__prices"><s class="nzs-sbr__was">$'+esc(p.compare_at_price_min)+'</s><span class="nzs-sbr__p nzs-sbr__p--sale">$'+esc(p.price)+'</span></span>'
            : '<span class="nzs-sbr__p">$'+esc(p.price)+'</span>';
          return '<a class="nzs-sbr__row" role="option" href="'+esc(p.url)+'">'+thumb(u)+'<span class="nzs-sbr__t">'+esc(p.title)+'</span>'+_ph+'</a>';
        }).join(''));
      }
      html += '<a class="nzs-sbr__all" href="/search?q='+encodeURIComponent(q)+'&type=product">View all results for \u201c'+esc(q)+'\u201d</a>';
      res.innerHTML=html; res.hidden=false; announce(Math.min(queries.length,4)+Math.min(cols.length,3)+prods.length);
    }
    function sbOpen(){ if(window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('search'); document.body.classList.add('nzs-search-open'); sb.classList.add('is-open'); sTog.setAttribute('aria-expanded','true'); setTimeout(function(){ if(!sb.classList.contains('is-open')) return; inp.focus(); if(!inp.value.trim()) defaultPanel(); }, 120); }
    function sbClose(o){ var restoreFocus=!(o&&o.restoreFocus===false)&&sb.contains(document.activeElement); /* NZS-SPD-0927-SM-N1: an Event argument never carries restoreFocus:false */ sb.classList.remove('is-open'); document.body.classList.remove('nzs-search-open'); sTog.setAttribute('aria-expanded','false'); hideRes(); if(restoreFocus) sTog.focus(); }
    window.__nzsSearchClose = sbClose;
    window.__nzsSurfaces.search = sbClose;
    sTog.addEventListener('click', function(e){ e.stopPropagation(); if(sb.classList.contains('is-open')) sbClose(); else sbOpen(); });
    sb.querySelector('.nzs-searchbar__close').addEventListener('click', sbClose);
    document.addEventListener('click', function(e){ if(sb.classList.contains('is-open') && !e.target.closest('#nzsSearchbar') && !e.target.closest('#navsearch')) sbClose(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') sbClose(); });
    res.addEventListener('click', function(e){ var a=e.target.closest('[data-q]'); if(a) pushRecent(a.getAttribute('data-q')); });
    inp.addEventListener('focus', function(){ if(!inp.value.trim()) defaultPanel(); });
    frm.addEventListener('submit', function(e){ var v=inp.value.trim(); if(!v){ e.preventDefault(); inp.focus(); return; } pushRecent(v); });
    inp.addEventListener('input', function(){
      var q = inp.value.trim();
      cancelSuggest();
      if(q.length < 2){ defaultPanel(); return; }
      sDeb = setTimeout(function(){
        var seq=sSeq;
        sCtrl = ('AbortController' in window) ? new AbortController() : null;
        res.setAttribute('aria-busy','true');
        sLoad=setTimeout(function(){ if(seq!==sSeq) return; res.insertAdjacentHTML('afterbegin','<div class="nzs-sbr__loading" data-nzs-suggest-loading aria-hidden="true"><span class="nzs-atc-dots"><i></i><i></i><i></i></span></div>'); res.hidden=false; },250);
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag', sCtrl ? {signal: sCtrl.signal} : {})
          .then(function(r){ return r.json(); })
          .then(function(d){ if(seq!==sSeq) return; clearSuggestBusy(); sCtrl=null; renderResults(q, d); })
          .catch(function(err){ if(seq!==sSeq) return; clearSuggestBusy(); sCtrl=null; if(err && err.name !== 'AbortError') hideRes(); });
      }, 220);
    });
  }
  /* fixed header: size the spacer from expanded chrome only (not the open drawer) so content isn't hidden */
  var nzsSpacerDirty=false, nzsExpanding=false, nzsExpandRun=0;
  function nzsSetSpacer(){
    if(document.body.classList.contains('nzs-hdr-compact')||nzsExpanding){ nzsSpacerDirty=true; return; }
    var bar=document.querySelector('.pill-bar'), sp=document.getElementById('nzsHdrSpacer');
    /* NZS-CWV-0923-S1: write the spacer + --nzs-hdr-b only when the value changed (no full restyle on every mobile URL-bar resize) */
    if(bar&&sp){ var v=Math.round(bar.getBoundingClientRect().bottom + 8)+'px'; if(sp.style.height!==v){ sp.style.height=v; document.documentElement.style.setProperty('--nzs-hdr-b', v); } nzsSpacerDirty=false; }
  }
  nzsSetSpacer();
  window.addEventListener('load', nzsSetSpacer);
  /* Compact resizes only mark dirty: the spacer matters near the top, where IO expands before it is exposed. */
  window.addEventListener('resize', nzsSetSpacer);
  var compactSentinel=document.getElementById('nzsHdrCompactSentinel');
  var compactReduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
  function nzsExpandHeader(){
    var body=document.body;
    if(!body.classList.contains('nzs-hdr-compact')) return;
    if(compactReduce&&compactReduce.matches){ body.classList.remove('nzs-hdr-compact'); if(nzsSpacerDirty) nzsSetSpacer(); return; }
    var bar=document.querySelector('.pill-bar'), compactPill=document.querySelector('.pill');
    var run=++nzsExpandRun, done=false, timer;
    function finish(e){
      if(e&&(e.target!==e.currentTarget||e.propertyName!=='height')) return;
      if(done) return; done=true;
      if(bar) bar.removeEventListener('transitionend',finish);
      if(compactPill) compactPill.removeEventListener('transitionend',finish);
      clearTimeout(timer);
      if(run!==nzsExpandRun) return;
      nzsExpanding=false;
      if(nzsSpacerDirty) nzsSetSpacer();
    }
    nzsExpanding=true;
    if(bar) bar.addEventListener('transitionend',finish);
    if(compactPill) compactPill.addEventListener('transitionend',finish);
    body.classList.remove('nzs-hdr-compact');
    timer=setTimeout(finish,250);
  }
  if(compactSentinel&&('IntersectionObserver' in window)){
    new IntersectionObserver(function(entries){
      var rect=entries[entries.length-1].boundingClientRect;
      if(rect.bottom<=0){ nzsExpandRun++; nzsExpanding=false; document.body.classList.add('nzs-hdr-compact'); }
      else if(rect.top>=0) nzsExpandHeader();
    },{threshold:[0,1]}).observe(compactSentinel);
  }
})();
